import axios from 'axios';
import * as Sentry from '@sentry/react';
import { FALLBACK_ERROR_MESSAGE } from '../utils/constants/form-message';

const API_URL = import.meta.env.VITE_API_URL;
const instance = axios.create({
  baseURL: API_URL,
  responseType: 'json',
  timeout: 300000,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      // No HTTP response at all: CORS, DNS, offline, timeout
      Sentry.captureException(error, {
        tags: { network_failure: 'true' },
        contexts: {
          request: {
            url: error.config?.url,
            method: error.config?.method,
          },
        },
      });
    }

    if (error.response && error.response.status === 500) {
      error.response.data.message = FALLBACK_ERROR_MESSAGE;
    }

    return Promise.reject(error);
  }
);

instance.interceptors.response.use((response) => response.data);

export default instance;
